export default theme => {
    return {}
}



// WEBPACK FOOTER //
// ./src/app/configuration/Genesis/theme/components/scorecard/MetricsLabels/index.js